/* Move Essential free shipping bar above the mini-cart button row */
(function () {
  'use strict';

  const css = `
    #cart-dropdown li.buttons {
      display: flex;
      flex-wrap: wrap;
      align-items: flex-end;
    }
    #cart-dropdown li.buttons [class*="free_shipping_card_wrapper"] {
      flex: 0 0 100%;
    }
    #cart-dropdown li.buttons .negative-left,
    #cart-dropdown li.buttons .negative-right {
      flex: 1 1 50%;
      float: none;
    }
    #cart-dropdown li.buttons .negative-left {
      padding-bottom: 16px;
    }
  `;

  const style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  const move = () => {
    const buttons = document.querySelector('#cart-dropdown li.buttons');
    if (!buttons) return;
    const bar = buttons.querySelector('[class*="free_shipping_card_wrapper"]');
    const left = buttons.querySelector('.negative-left');
    if (!bar || !left || bar.parentElement === buttons) return;
    buttons.insertBefore(bar, left);
  };

  move();
  new MutationObserver(move).observe(document.body, { childList: true, subtree: true });
})();